import React, { PureComponent } from 'react';

import DataTableContext from './DataTableContext';
import DataTableHeaderCell from './DataTableHeaderCell';

class DataTableHeaderColumns extends PureComponent {
  render() {
    return (
      <DataTableContext.Consumer>
        {({ actions, data }) =>
          data.columns.map((column, i) => (
            <DataTableHeaderCell
              key={`row-${i}`}
              className={column.className}
              label={column.label}
              name={column.value}
              sortName={column.sortName}
              onClick={() => actions.onCellClick(column)}
              orderBy={column.sortName && data.sortOptions[column.sortName]}
            />
          ))
        }
      </DataTableContext.Consumer>
    );
  }
}

export default DataTableHeaderColumns;
